"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatUserStatus(object) {
    return checkExternalChatUserStatus(object).fulfilled;
}
exports.isExternalChatUserStatus = isExternalChatUserStatus;
function checkExternalChatUserStatus(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("userId"), __1.hasChoice("type", ["online", "offline", "idle"]), __1.hasString("text").optional(), __1.hasNumber("expiresAt").optional()).withOptions(options).explain();
}
exports.checkExternalChatUserStatus = checkExternalChatUserStatus;
//# sourceMappingURL=ExternalChatUserStatus.js.map